import React, { useState } from "react";
import ConfForm from "../../configurator/form";
import { InputText } from "../components/style/InputText";
import FormHandler from "./FormHandler";
import { prepareProductFormData } from "../functions/formatProduct";

const Form = ({ activeProduct, isActive, price, legPrice, formCode }) => {
  new ConfForm();
  const fieldsInitial = {
    ime: "",
    prezime: "",
    email: "",
    location: "",
    poruka: "",
  };
  const formFields = [
    {
      label: "Ime",
      name: "ime",
      type: "text",
      mandatory: true,
    },
    {
      label: "Prezime",
      name: "prezime",
      type: "text",
      mandatory: true,
    },
    {
      label: "Email",
      name: "email",
      type: "email",
      mandatory: true,
    },
    {
      label: "Mesto stanovanja",
      name: "location",
      type: "text",
      mandatory: true,
    },
    {
      label: "Poruka",
      name: "poruka",
      type: "textarea",
      mandatory: true,
    },
  ];
  const [fields, setFields] = useState(fieldsInitial);
  const [sent, setSent] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const handleFormSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    const form = new FormData();
    for (let key in fields) {
      form.append(
        key,
        Array.isArray(fields[key]) ? fields[key].toString() : fields[key]
      );
    }
    form.append("_wpcf7_unit_tag", "wpcf7-f1717-123");
    form.append("Cena", parseInt(price) + parseInt(legPrice) + " €");
    const productFields = prepareProductFormData(activeProduct);
    Object.entries(productFields).forEach(([key, value]) => {
      form.append(key, value);
    });
    fetch(process.env.FORM_API + formCode + "/feedback", {
      method: "POST",
      body: form,
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.status !== "mail_sent") throw resp.message;
        setSent(true);
      })
      .catch((error) => {
        setError(error);
        setSent(false);
      })
      .finally(() => {
        setFields(fieldsInitial);
      });
  };
  return (
    isActive && (
      <div className="conf-form">
        <div className="conf-form__content">
          <h2 className="h2">Upit</h2>
          {submitted ? (
            <FormHandler
              error={error}
              sent={sent}
              text={"Vasa konfiguracija je poslata!"}
            />
          ) : (
            <form onSubmit={handleFormSubmit} action="">
              {formFields.map((item, index) => {
                return (
                  <InputText
                    label={item.label}
                    type={item.type}
                    name={item.name}
                    key={index}
                    mandatory={item.mandatory}
                    setFields={setFields}
                    fields={fields}
                  />
                );
              })}
              <p className="submit"></p>
              <button className="btn beige" type="submit">
                Pošalji
              </button>
            </form>
          )}
        </div>
      </div>
    )
  );
};

export default Form;
